import styled from 'styled-components';

import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(SegmentLayoutComponent)`
  display: flex;
  flex-direction: column;

  &.ui.segment {
    margin-bottom: 20px;
    padding: 15px;
    width: 400px;
  }
`;

export const Content = styled.div`
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 5px;
`;

export const Text = styled(TextLayoutComponent)`
  ${(props) => props.remove && `
    color: ${props.theme.color.textErrorProjetSetUp};
    cursor: pointer;
  `}

  ${(props) => props.flag && `
    color: ${props.theme.color.flagText};
  `}
`;

export const TextError = styled(TextLayoutComponent.Error)``;

export const Link = styled.a``;

export const DefaultFlag = styled.div`
  align-items: center;
  background: ${(props) => props.theme.color.flag};
  padding: 3px;
  border-radius: 7px;
  display: inline-flex;
  justify-content: center;
  width: 55px;
`;
